/**
 * Almacenamiento persistente: pide al navegador que no borre los datos si falta espacio. Safari 15
 * no lo garantiza para las webs, pero la app instalada queda fuera del borrado por inactividad
 * (§9.5). Es una petición de mejor esfuerzo; la copia de seguridad sigue siendo la red de seguridad.
 */
export async function requestPersistence(): Promise<boolean | null> {
  try {
    const storage = navigator.storage
    if (!storage || typeof storage.persist !== 'function') return null
    if (await storage.persisted()) return true
    return await storage.persist()
  } catch {
    return null
  }
}

export async function isPersisted(): Promise<boolean | null> {
  try {
    const storage = navigator.storage
    if (!storage || typeof storage.persisted !== 'function') return null
    return await storage.persisted()
  } catch {
    return null
  }
}
